import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ClientService } from '@app/core/client.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-staff-modal',
  templateUrl: './confirm-staff-modal.component.html',
  styleUrls: ['./confirm-staff-modal.component.scss']
})
export class ConfirmStaffModalComponent implements OnInit {
  @Input() public title: string;

  isInvalidCode: boolean = false;
  loading: boolean = false;
  staffCodeForm: FormGroup = this.fb.group({
    staffCode: ['', [Validators.required, Validators.pattern(/^[A-Za-z0-9_-]+$/)]]
  });

  constructor(
    public modal: NgbActiveModal,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private clientService: ClientService
  ) {}

  ngOnInit() {
    this.staffCodeForm.get('staffCode').valueChanges.subscribe(() => {
      this.isInvalidCode = false;
    });
  }

  onSubmit() {
    if (this.staffCodeForm.invalid) {
      this.staffCodeForm.markAllAsTouched();
      return;
    }

    const staffCode = this.staffCodeForm.value.staffCode;
    this.loading = true;
    this.isInvalidCode = false;

    this.clientService.verifyStaffCode(staffCode).subscribe({
      next: res => {
        this.loading = false;
        if (!res.valid) {
          this.isInvalidCode = true;
        } else {
          this.staffCodeForm.markAsUntouched();
          this.staffCodeForm.reset();
          this.modal.close({
            success: true,
            data: res
          });
        }
      },
      error: () => {
        this.loading = false;
        this.isInvalidCode = true;
      }
    });
  }
}
